import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useCreatePointCategory = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('createPointCategory', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['point-management'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};

export const useUpdatePointCategory = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updatePointCategory', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['point-management'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};

export const useUpdatePointCategoryStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updatePointCategoryStatus', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['point-management'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};

export const useDeletePointCategory = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('deletePointCategory', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['point-management'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};

export const useAssignPointCategory = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('assignPointCategory', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['point-management'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};
